(function () {
    'use strict';

    angular
        .module('mnp.tracking', ['ngSanitize'])
        .factory('trackingSrv', trackingSrv);

    trackingSrv.$inject = ['$state','$injector','mnpNbaProvider'];

    function trackingSrv($state, $injector, mnpNbaProvider) {

    	var config = $injector.get('config');
        var srv = this;

    	srv.E_TYPE_VALIDATION = "validation";
    	srv.E_TYPE_TECHNICAL = "technical";
    	srv.E_TYPE_NOTIFICATION = "notification";

        srv._ddq = window._ddq || [];

        srv.getSiteStructure = function (moduleName) {
    		var siteStructure = config.tracking.siteStructure.slice(); //create copy of array
            var mnpSite = $state.current.url.substr(1);
            if (mnpSite){
                siteStructure.push(mnpSite);
            }
            return siteStructure;
        };

        srv.trackForm = function (module, step, stepName, status, formData, siteStructure) {

        	var data = [
                'pageview', {
	                'siteArea': config.tracking.siteArea,
	                'platformType': config.tracking.platformType,
	                'siteStructure': siteStructure,
	                'pageType': config.tracking.pageType,
	                'loginStatus': srv.getLoggedIn(),
	                'oForm': {
	                    name: module,
	                    formtype: 'ecare',
	                    formStep: step,
	                    formStepName: stepName,
	                    formStatus: status,
	                    oApplication: {
	                        type: 'porting:transaction',
	                        name: module
	                    }
	                }
                }
            ];

            if (formData) {
                for (var key in formData) {
                	data['pageview'][key] = formData[key];
                }
            }
            srv.track(data);
        };

        srv.trackPageView = function (siteStructure) {
        	var loggedIn = mnpNbaProvider.isUserLogged() ? 'logged in' : 'not logged in';
        	var data = [
                'pageview', {
                    'siteArea': config.tracking.siteArea,
                    'platformType': config.tracking.platformType,
                    'siteStructure': siteStructure,
                    'pageType': config.tracking.pageType,
                    'loginStatus': srv.getLoggedIn()
                }
            ];
            srv.track(data);
        };

        srv.trackError = function (code, type, message, location) {
        	var data = [
                'error', {
                    // mandatory, options: "validation","technical", "notification"

                    'type': type,
                    // mandatory, description of the error
                    'message': message,
                    // optional, error code when applicable
                    'code': code,
                    // optional, location or field of the error
                    'location': location
                }
            ];
        	srv.track(data);
        };

        srv.getLoggedIn = function () {
        	return mnpNbaProvider.isUserLogged() ? 'logged in' : 'not logged in';
        };

        srv.track = function(data){
    		srv._ddq.push(data);
        }

        return srv;

    }


}());
